<template>
  <div>
    <!-- 顶部导航 -->
    <home-header v-if="pgType == 'todo'" />

    <div class="fill-info-page">
      <!-- 审核状态 -->
      <div v-if="!pgType || pgType !== 'todo'">
        <div class="warp" :style="{ height: isOpen ? 'auto' : '40px' }">
          <template v-if="auditMode == 0">
            <p class="text">
              采集状态：
              <span>{{ reviewStatus == 0 ? '待提交' : '已提交' }}</span>
            </p>
          </template>
          <template v-else>
            <p class="text" :class="isOpen ? '' : 'clamp'">
              审核状态：
              <span v-if="auditMode == 1">{{ autoState }}</span>
              <span v-if="auditMode == 2">{{ state }}</span>
              <template v-if="reviewStatus > 1">
                审核意见：
                <span>{{ reviewRemark }}</span>
              </template>
            </p>
            <span class="butn" @click="isOpen = !isOpen" v-if="reviewStatus > 1">
              <a-icon :type="isOpen ? 'up' : 'down'" />
            </span>
          </template>
        </div>
      </div>

      <a-collapse ref="collapse" :default-active-key="panelKeys">
        <a-collapse-panel v-for="(item, index) in itemList" :key="String(index)" :header="getTitleDesc(item)">
          <student-base-info
            v-if="item.itemCode == 'BASE'"
            :ref="'itemRef_' + item.itemCode"
            :fieldData="item.fieldData"
            :imgData="item.imgData"
            :editFlag="editFlag"
          />
          <item-list-table
            v-else
            :ref="'itemRef_' + item.itemCode"
            :itemColumn="item.columns"
            :fieldData="item.fieldData"
            :editFlag="editFlag"
            :minNum="item.minNum"
            :maxNum="item.maxNum"
            @getDelIds="getDelIds"
          />
        </a-collapse-panel>
      </a-collapse>

      <div class="con-button">
        <!-- 手机扫码签名 -->
        <Sign
          v-if="editFlag"
          ref="signRef"
          type="collect"
          :showLogSign="false"
          :docId="projectId"
          :disabled="auditMode === 2 && (reviewStatus === 2 || reviewStatus === 3)"
          @ok="handleSignOk"
          @open="signSubmit"
        />
        <a-button @click="closePage" style="margin: 0 12px">关闭</a-button>
        <a-button v-if="editFlag" @click="saveDraft" :disabled="auditMode === 2 && (reviewStatus === 2 || reviewStatus === 3)">暂存</a-button>
      </div>

      <a-modal :visible="showSign" :maskClosable="false" :closable="true" @cancel="handleCancel" :footer="null" title="签名" :width="500">
        <person-sign @getSign="signCallBack" />
      </a-modal>
    </div>

    <!-- 底部版权信息 -->
    <Foot ref="footer" v-if="pgType == 'todo'" />
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import NationSelect from './components/NationSelect'
import StudentBaseInfo from './components/StudentBaseInfo'
import ItemListTable from './components/ItemListTable'
import PersonSign from './components/PersonSign'
import Sign from '@/common/components/sign.vue'
import Foot from '@/common/components/Foot'
import { mapState } from 'vuex'
import dayjs from 'dayjs'

export default {
  name: 'FillInInformation',
  components: {
    HomeHeader,
    Foot,
    NationSelect,
    StudentBaseInfo,
    ItemListTable,
    PersonSign,
    Sign
  },
  data() {
    return {
      panelKeys: ['0', '1', '2', '3'],
      projectId: this.$route.query.pid,
      bid: this.$route.query.bid,
      pgType: this.$route.query.pt || null,
      editFlag: true,
      showSign: false,
      signStr: null,
      projectInfo: {},
      itemList: [],
      textAreaFields: [],
      requireColumns: [],
      delItemIds: [],
      requireItems: {},
      reviewStatus: 0, // 审核状态
      reviewRemark: '', // 审核意见
      isOpen: false,
      auditMode: '' // 审核模式
    }
  },
  created() {
    this.getProjectItems()
  },
  computed: {
    ...mapState(['userInfo']),

    state() {
      const statusEnum = {
        0: '待提交',
        1: '待审核',
        2: '学校审核通过',
        3: '教学点审核通过',
        4: '审核驳回'
      }
      return statusEnum[this.reviewStatus]
    },

    autoState() {
      const statusEnum = {
        0: '待提交',
        1: '待审核',
        2: '审核通过',
        3: '教学点审核通过',
        4: '审核驳回'
      }
      return statusEnum[this.reviewStatus]
    }
  },
  mounted() {
    // this.getStudentInfo()
  },
  methods: {
    // 查询项目条目配置
    getProjectItems() {
      const that = this
      const url = '/biz/infocollect/getProjectItems'
      const param = {
        pid: that.$route.query.pid
      }
      that.axios.get(url, { params: param }).then(res => {
        if (res.success) {
          that.getStudentInfo()

          const resData = res.result
          that.editFlag = resData.editFlag
          that.auditMode = resData.auditMode

          const itemList = resData.itemList || []
          itemList.forEach(item => {
            const itemCode = item.itemCode
            const fieldData = item.fieldData || []
            if (itemCode !== 'BASE') {
              that.requireColumns[itemCode] = []
              let columns = []
              fieldData.forEach(item => {
                let dataIndex = item.index
                let tmpColumn = {}
                if (item.required) {
                  that.requireItems[itemCode] = true
                  that.requireColumns[itemCode].push(item)
                  tmpColumn = {
                    title: () => (
                      <span>
                        <span style="color: red;margin-right: 4px;vertical-align: middle;line-height: 1;">*</span>
                        {item.label}
                      </span>
                    ),
                    dataIndex: dataIndex,
                    align: 'center',
                    required: item.required,
                    edit: item.edit,
                    width: 150,
                    ellipsis: true,
                    scopedSlots: { customRender: dataIndex }
                  }
                } else {
                  tmpColumn = {
                    title: item.label,
                    dataIndex: dataIndex,
                    align: 'center',
                    required: item.required,
                    edit: item.edit,
                    width: 150,
                    ellipsis: true,
                    scopedSlots: { customRender: dataIndex }
                  }
                }
                columns.push(tmpColumn)
              })
              item.columns = columns
            } else {
              that.textAreaFields = []
              fieldData.forEach(item => {
                if (item.type === 'textarea') {
                  that.textAreaFields.push(item.index)
                }
              })
            }
          })
          that.itemList = itemList
        }
      })
    },

    // 查询学生采集信息
    getStudentInfo() {
      const that = this
      const url = '/biz/infocollect/getCollectStudent'
      const param = {
        pid: that.$route.query.pid,
        sid: that.userInfo.id
      }
      that.axios.get(url, { params: param }).then(res => {
        if (res.success) {
          const resData = res.result
          that.textAreaFields.forEach(item => {
            if (!resData[item]) {
              resData[item] = '无'
            }
          })
          that.$refs['itemRef_BASE'][0].formData = resData
          that.signStr = resData.sign
          that.reviewStatus = resData.reviewStatus
          that.reviewRemark = resData.reviewRemark || resData.siteReviewRemark

          const itemDetails = resData.itemDetails || []
          const groups = []
          const itemCodeList = []
          if (itemDetails.length > 0) {
            itemDetails.forEach(item => {
              if (item.endDate === '至今') {
                item.endDate = '9999-12-31'
              }
              item.tmpId = item.id
              if (itemCodeList.indexOf(item.itemCode) === -1) {
                itemCodeList.push(item.itemCode)
              }
              if (!groups[item.itemCode]) {
                groups[item.itemCode] = []
              }
              groups[item.itemCode].push(item)
            })
            itemCodeList.forEach(item => {
              let ref = 'itemRef_' + item
              that.$refs[ref][0].dataSource = groups[item]
            })
          }
        }
      })
    },

    // 获取采集条目限制描述
    getTitleDesc(item) {
      let desc = item.titleDesc
      let minNum = item.minNum
      let maxNum = item.maxNum
      let tipInfo = ''
      if ((!maxNum || maxNum === 0) && (!minNum || minNum === 0)) {
        return desc
      } else if (minNum > 0 && maxNum > 0) {
        if (minNum === maxNum) {
          tipInfo = '(限制' + maxNum + '条记录)'
        } else {
          tipInfo = '(限制' + minNum + '-' + maxNum + '条记录)'
        }
      } else if (minNum > 0 && (!maxNum || maxNum === 0)) {
        tipInfo = '(至少填写' + minNum + '条记录)'
      } else if ((!minNum || minNum === 0) && maxNum > 0) {
        tipInfo = '(限制' + maxNum + '条记录)'
      }
      return desc + tipInfo
    },

    // 获取删除item id
    getDelIds(val) {
      this.delItemIds = this.delItemIds.concat(val.split(','))
    },

    // 扫码签名
    handleSignOk(fileUrl) {
      this.signStr = fileUrl
      this.submitInfo()
    },

    // 关闭页面
    closePage() {
      if (this.pgType && this.pgType === 'todo') {
        this.$router.push({ path: '/todos/list' })
      } else {
        this.$router.push({ path: `/personalcenters/infocollectindex?pid=${this.projectId}` })
      }
    },

    // 取消签名
    handleCancel() {
      this.showSign = false
    },

    // 签名提交
    signSubmit() {
      if (this.pgType === 'todo') {
        this.submitCheck()
      } else {
        this.axios.get('/biz/infocollect/fillCheck').then(res => {
          if (res.success) {
            this.submitCheck()
          } else {
            this.$message.warning(res.message)
            return false
          }
        })
      }
    },
    // 提交检查
    submitCheck() {
      const that = this
      that.$refs['itemRef_BASE'][0].$refs['form'].validate(valid => {
        if (valid) {
          // 校验采集条目
          for (var i = 0; i < that.itemList.length; i++) {
            var proItem = that.itemList[i]
            if (proItem.itemCode === 'BASE') {
              const baseInfo = that.$refs['itemRef_BASE'][0].formData
              let imgArr = proItem.imgData || []
              for (var j = 0; j < imgArr.length; j++) {
                var field = imgArr[j]
                if (field.required && !baseInfo[field.index]) {
                  that.$message.error(field.label + '不能为空')
                  return false
                }
              }
            } else {
              let ref = 'itemRef_' + proItem.itemCode
              const dataList = that.$refs[ref][0].dataSource || []
              const requireColumns = that.requireColumns[proItem.itemCode] || []
              // 必填列表非空校验
              if (requireColumns.length > 0 && dataList.length === 0) {
                that.$message.error(proItem.titleDesc + '列表不能为空')
                return false
              }
              let minNum = proItem.minNum
              let maxNum = proItem.maxNum
              if (minNum > 0 && dataList.length < minNum) {
                that.$message.error(proItem.titleDesc + '列表至少需要填写' + minNum + '条记录')
                return false
              }
              if (maxNum > 0 && dataList.length > maxNum) {
                that.$message.error(proItem.titleDesc + '列表最大限制填写' + maxNum + '条记录')
                return false
              }
              let preDate = null
              for (var m = 0; m < dataList.length; m++) {
                let rowData = dataList[m]
                for (var n = 0; n < requireColumns.length; n++) {
                  var column = requireColumns[n]
                  if (column.required && !rowData[column.index]) {
                    that.$message.error(column.label + '不能为空')
                    return false
                  }
                }
                if (proItem.itemCode === 'EDUCATE' || proItem.itemCode === 'WORK') {
                  if (rowData.startDate && rowData.endDate) {
                    if (rowData.startDate === '9999-12-31') {
                      that.$message.error(proItem.titleDesc + '列表中开始日期不能为至今')
                      return false
                    }
                    if (rowData.endDate !== '9999-12-31' && dayjs(rowData.endDate).isBefore(dayjs(rowData.startDate))) {
                      that.$message.error(proItem.titleDesc + '列表中开始日期不能晚于结束日期')
                      return false
                    }
                    if (preDate != null && dayjs(rowData.startDate).isBefore(dayjs(preDate))) {
                      that.$message.error(proItem.titleDesc + '列表请按照日期先后顺序依次填写')
                      return false
                    }
                    preDate = rowData.startDate
                  }
                }
              }
            }
          }
          // that.showSign = true
          this.$refs.signRef.openSign()
        } else {
          that.$message.error('表单必填项校验失败')
          return false
        }
      })
    },

    // 签名完成回调
    signCallBack(val) {
      this.signStr = val
      this.showSign = false
      this.submitInfo()
    },

    // 提交信息
    submitInfo() {
      const that = this
      const baseInfo = that.$refs['itemRef_BASE'][0].formData
      let detailList = []
      that.itemList.forEach(item => {
        if (item.itemCode !== 'BASE') {
          let ref = 'itemRef_' + item.itemCode
          const list = that.$refs[ref][0].dataSource || []
          list.forEach(vo => {
            vo.itemCode = item.itemCode
          })
          detailList = detailList.concat(list)
        }
      })
      const params = Object.assign({}, baseInfo)
      params.sign = that.signStr
      params.projectId = that.projectId
      params.delIds = that.delItemIds.join(',')
      params.itemDetails = detailList
      // 待办提交属性
      params.businessId = that.bid
      params.pgType = that.pgType
      const url = '/biz/infocollect/editStuInfo'
      that.axios.post(url, params).then(res => {
        if (res.success) {
          that.$message.success(res.result)
          setTimeout(() => {
            if (that.bid && that.pgType === 'todo') {
              that.$router.push({ path: '/todos/list' })
            } else {
              that.closePage()
            }
          }, 1000)
        } else {
          that.$message.error(res.result)
        }
      })
    },

    // 保存草稿
    saveDraft() {
      const that = this
      const baseInfo = that.$refs['itemRef_BASE'][0].formData
      let detailList = []
      that.itemList.forEach(item => {
        if (item.itemCode !== 'BASE') {
          let ref = 'itemRef_' + item.itemCode
          const list = that.$refs[ref][0].dataSource || []
          list.forEach(vo => {
            vo.itemCode = item.itemCode
          })
          detailList = detailList.concat(list)
        }
      })
      const params = Object.assign({}, baseInfo)
      params.projectId = that.projectId
      params.delIds = that.delItemIds.join(',')
      params.itemDetails = detailList
      // 待办提交属性
      params.businessId = that.bid
      params.pgType = that.pgType
      params.isDraft = true
      const url = '/biz/infocollect/saveDraft'
      that.axios.post(url, params).then(res => {
        if (res.success) {
          that.$message.success(res.result)
          setTimeout(() => {
            that.getStudentInfo()
          }, 1000)
        } else {
          that.$message.error(res.result)
        }
      })
    }
  }
}
</script>
<style scoped>
.fill-info-page {
  max-width: 1208px;
  background-color: #f8f8ff;
  margin: 0 auto;
  padding: 12px 24px;
}

.text span {
  color: #fc484e;
  margin-right: 10px;
}

.warp {
  background-color: #fefaed;
  line-height: 30px;
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  padding-right: 60px;
  width: 100%;
  transition: height 0.3s;
}

.clamp {
  padding-right: 60px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.butn {
  position: absolute;
  right: 20px;
  top: 8px;
  color: #2caf7a;
  cursor: pointer;
}

.fill-info-page >>> .ant-collapse-header {
  background: rgba(44, 175, 122, 0.18);
  text-align: left;
  font-weight: 400;
  font-size: 18px;
  height: 45px;
}
.fill-info-page >>> .ant-collapse-content-box {
  padding: 0;
}
.con-button {
  padding: 12px 0;
  text-align: center;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/infocollect/FillInformation.vue